import * as React from "react";
import { useEffect, useState } from "react";
import { Button, Modal, Steps, Input, Form, Result, Space } from "antd";
import { useStepsForm } from "sunflower-antd";

import { getGroupsApi } from "../../../services/Group/GroupApis";
import { getPlansApi } from "../../../services/Product/ProductApis";

const { Step } = Steps;

interface IModalProps {
  show: boolean;
  addon: any;
  showModal: Function;
  handleUpdate: Function;
}

const EditAddonModal: React.FC<IModalProps> = ({
  show,
  addon,
  showModal,
  handleUpdate,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const {
    form,
    current,
    gotoStep,
    stepsProps,
    formProps,
    submit,
    formLoading,
  } = useStepsForm({
    isBackValidate: false,
    defaultFormValues: addon,
    async submit(values: any) {
      setLoading(true);

      const response = await handleUpdate(addon.id, { ...values });

      if (response.success) {
        setLoading(false);
        return true;
      }
      setErrorMsg(response.message);
      setLoading(false);
      return false;
    },
    total: 3,
  });

  // Step Styling
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
  };

  const tailLayout = {
    labelCol: { span: 8 },
    wrapperCol: { offset: 8, span: 8 },
  };

  const formList = [
    <>
      <Form.Item
        name="Name"
        label="Addon Name"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Addon Name" />
      </Form.Item>
      <Form.Item
        name="CoverAmount"
        label="Cover Amount"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Cover Amount" />
      </Form.Item>

      <Form.Item
        name="Premium"
        label="Premium"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Premium" />
      </Form.Item>

      <Form.Item
        name="UnderwritingFee"
        label="Underwriting Fee"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" placeholder="Underwriting Fee" />
      </Form.Item>

      <Form.Item {...tailLayout}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button
            style={{ marginBottom: 10 }}
            block
            size="large"
            loading={formLoading}
            onClick={() => {
              submit().then((result) => {
                if (result) {
                  gotoStep(current + 1);
                } else if (!result) {
                  gotoStep(current + 2);
                }
              });
            }}
          >
            Submit
          </Button>
        </Space>
      </Form.Item>
    </>,
  ];

  return (
    <Modal
      title="New Addon"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={600}
      footer={null}
    >
      {/* Steps Form */}
      <div>
        <div style={{ marginTop: 60 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 1100 }}>
            {formList[current]}
          </Form>

          {current === 1 && (
            <Result status="success" title="Successfully submitted.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button
                  loading={loading}
                  block
                  size="large"
                  onClick={handleModal}
                >
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 2 && (
            <Result status="error" title={errorMsg}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default EditAddonModal;
